module.exports = __webpack_public_path__ + "static/media/REW_homepage.32d30f89.jpg";